export default __webpack_public_path__ + "static/media/lms.968f7b1e.png";